
import React, {useState, useEffect} from 'react'
import { BrowserRouter as Router, Routes, Route,Navigate, redirect } from 'react-router-dom';

import './assets/main.css'

import ProtectedRoute from './utils/ProtectedRoutes';

import Login from './components/Login'
import Home from "./components/Home"
import GridContainer from "./components/GridContainer"
import Sockets from './utils/Sockets';

// MOBILE
import MobileAppContainer from "./components/mobile/MobileAppContainer"
import MobileTrade from "./components/mobile/MobileTrade"
import MobileNavbar from './components/mobile/MobileNavbar'
import MobileMyProfile from './components/mobile/MobileMyProfile';
import MobileSettings from './components/mobile/MobileSettings';
import MobileMyOrders from './components/mobile/MobileMyOrders';


// STORES
import useGridStore from './stores/GridStore'
import useUserStore from './stores/UserStore';
import useToolsStore from './stores/ToolsStore';

function App() {
  const {userToken, userID, connected} = useUserStore()
  const {isMobile, isTablet, isPortrait, setIsMobile, setIsTablet, setIsPortrait} = useToolsStore()
  const resetTabletDefault = useGridStore((state) => state.resetTabletDefault)
  const resetTabletPortraitDefault = useGridStore((state) => state.resetTabletPortraitDefault)
 
  const checkIsMobile = () => {
    const mobileMediaQuery = window.matchMedia('(max-width: 649px)'); 
    
    setIsMobile(mobileMediaQuery.matches);
  };
  const checkIsPortrait = () => {
    const mobileMediaQueryPortrait = window.matchMedia('(min-width: 650px) and (max-width: 1000px)'); 
    console.log("CHECK PORTRAIT", mobileMediaQueryPortrait)
    setIsPortrait(mobileMediaQueryPortrait.matches);
    if (mobileMediaQueryPortrait.matches) {
      resetTabletPortraitDefault()
    }
  };
  const checkIsTablet = () => {
    const mobileMediaQueryTablet = window.matchMedia('(min-width: 1001px) and (max-width: 1400px)'); 
    setIsTablet(mobileMediaQueryTablet.matches);
    if (mobileMediaQueryTablet.matches) {
      resetTabletDefault()
    }
  };
  
  useEffect(() => {
    checkIsMobile();
    checkIsTablet()
    checkIsPortrait()
    window.addEventListener('resize', checkIsMobile);
    window.addEventListener('resize', checkIsPortrait);
    window.addEventListener('resize', checkIsTablet);
    
    return () => {
      window.removeEventListener('resize', checkIsMobile);
      window.removeEventListener('resize', checkIsPortrait);
      window.removeEventListener('resize', checkIsTablet);
      
    };
  }, []);
  // useEffect(() => {
  //   if (isTablet) {
  //     setDefaultLayout('tablet');
  //   } else {
  //     setDefaultLayout('desktop');
  //   }
  // }, [isTablet, setDefaultLayout]);

  if (isMobile) {
    return (
      <Router>
      <div className='App'>
        <Routes>
        {/* <Route path='/' exact element={<Home/>}/> */}
          <Route path='/login' exact element={<Login/>}/>
          <Route path='/' element={ userID && userToken ? <MobileAppContainer/> : <Login/>} />
          <Route path='*' element={<Navigate to='/'/>}/>

        </Routes>
      </div>
    </Router>
    )
  }
  return (
    <Router>
      <div className='App'>
        <Routes>
        {/* <Route path='/' exact element={<Home/>}/> */}
          <Route path='/login' exact element={<Login/>}/>
          <Route path='/' element={ userID && userToken ? <GridContainer/> : <Login/>} />
          {/* <Route path='/trade' element={<GridContainer/>} /> */}
          <Route path='*' element={<Navigate to='/'/>}/>

        </Routes>
      </div>
    </Router>
  );
}

export default App;
